import React, { PureComponent } from 'react';
import { DetailedSolution, RegulationImpact } from 'app/model/SOL49';
import { Flex } from '../../common/Flex';
import { SolutionSummary } from './SolutionSummaryPanel';
import { RegulationDto } from 'app/model/CORE';
import { RegulationImpactPanel } from './RegulationImpactPanel';
import MeasureUtils from '../../../common/util/MeasureUtils';
import { Button } from 'antd';
import { ModalHandler } from '../ModalHandler';
import ConditionalRender from '../../../common/components/ConditionalRender';
import AuthorisationUtils from '../../../common/context/AuthorisationUtils';
import AppContext from 'app/common/context/AppContext';

interface SolutionImpactPanelProps {
    solution: DetailedSolution;
    onShareSolution: () => void;
}

export class SolutionImpactPanel extends PureComponent<SolutionImpactPanelProps> {
    public static INITIAL_WIDTH = '75em';

    shareSolution = () => {
        ModalHandler.showShareSolutionPanel([this.props.solution], [this.props.solution], this.props.onShareSolution);
    };

    render() {
        const solution = this.props.solution;
        const regulation = solution.measures[0] as RegulationDto;
        const regulationImpact = solution.solutionImpact?.measureImpacts[regulation.measureId.id] as RegulationImpact;
        const monitoredTv =
            regulation &&
            solution.solutionImpact?.tvImpact?.find(
                tvImpact => tvImpact.tvId === MeasureUtils.getTvLocation(regulation).id,
            )?.monitoredTv;
        return (
            <Flex direction="vertical">
                <Flex grow={false}>
                    <div style={{ border: '1px solid #424242', borderRadius: '0.5em' }}>
                        <SolutionSummary solution={solution} />
                    </div>
                </Flex>
                <RegulationImpactPanel
                    regulation={regulation}
                    regulationImpact={regulationImpact}
                    withoutEditor={true}
                    monitoredTv={monitoredTv}
                />
                <ConditionalRender condition={AppContext.isFmpCoordinationEnabled() && AuthorisationUtils.isNmUser()}>
                    <Button style={{ alignSelf: 'flex-end' }} onClick={this.shareSolution}>
                        Share
                    </Button>
                </ConditionalRender>
            </Flex>
        );
    }
}
